export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjMwYjBiYmY0LWQ1MzQtNGU1ZS04NWYzLWM2Y2E3MTNhNzJhNiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.vNpxWrq3T2OIZvxnNSxlUMWsJqrTNbE1PnCD8XaxIORV62TwTGSBi7AG5+Az5dIJ0Ggn/HvK+iUrByo4V6mSW8gUec6n7jheUqi3Qu/DOYSoegpRQbDPGhUu6jtNXrkXOdK+Wg==';
